// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA0BEv-V3lUqJEnkpMItouu_McxR22jbDQ",
  authDomain: "animal-ngo.firebaseapp.com",
  projectId: "animal-ngo",
  storageBucket: "animal-ngo.appspot.com",
  messagingSenderId: "526074453138",
  appId: "1:526074453138:web:7ec6fc91c3137cc7ba9a4b",
  measurementId: "G-03YN3DXVZ1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

export default app;